import { makeStyles, shorthands, tokens } from "@fluentui/react-components";

export const useStyle = makeStyles({
	menuPopoverContainer: {
		zIndex: "var(--popover-z-index)",
		paddingRight: 0,
		paddingLeft: 0,
		...shorthands.border(0),
		maxWidth: "16rem",
	},
	trigger: {
		...shorthands.margin(0),
		...shorthands.padding(0),
		...shorthands.border(0),
		cursor: "pointer",
		backgroundColor: tokens.colorTransparentBackground,
		width: "100%",
	},
});
